var App = App || {};

App.PrimaryNav = (function ($) {
    "use strict";

    var $nav,
        onTimer = {},
        offTimer = {},
        focusList = [],
        focusIndex = 0,
        currentMenu = null;

    function init() {
        $nav = $('#primary-nav');

        $(window).on('keydown', function (e) {
            if (currentMenu && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) > -1) {
                e.preventDefault();

                //Escape
                if (e.key === 'escape') {
                    closeMenu(currentMenu);
                }
            }
        });

        $nav.on('keydown', '.primary-nav__level-1-item--has-children > a', function (e) {
            var $this = $(this),
                $parent = $this.parent('li');

            if (!$parent.hasClass('primary-nav__level-1-item--open') && e.key === 'Enter') {
                e.preventDefault();
                openMenu($parent);
            }

            //left
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                $parent.prev('li')
                    .find(' > a')
                    .trigger('focus');
            }

            //right
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                $parent.next('li')
                    .find(' > a')
                    .trigger('focus');
            }

            //down
            if ($parent.hasClass('primary-nav__level-1-item--open') && e.key === 'ArrowDown') {
                e.preventDefault();
                focusList[0].focus();
            }
        });

        $nav.on('keydown', '.primary-nav__menu', function (e) {
            var $parent = $nav.find('.primary-nav__level-1-item--open');

            //down
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (focusIndex !== focusList.length - 1) {
                    focusIndex++;
                }

                focusList[focusIndex].focus();
            }

            //up
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (focusIndex !== 0) {
                    focusIndex--;
                }
                focusList[focusIndex].focus();
            }

            //left
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                $parent.prev('li').find(' > a').focus();
            }

            //right
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                $parent.next('li').find(' > a').focus();
            }
        });

        $nav.find('.primary-nav__level-1-item--has-children > a, .primary-nav__level-1-item > .primary-nav__menu')
            .on('mouseenter focusin', function () {
                var $this = $(this).parents('li'),
                    key = $this.find('> a')[0].innerText;

                clearTimeout(offTimer[key]);

                if (!$this.hasClass('primary-nav__level-1-item--open')) {
                    onTimer[key] = setTimeout(function () { openMenu($this); }, 100);
                }
            });

        $nav.find('.primary-nav__level-1-item--has-children')
            .on('mouseleave focusout', function () {
                var $this = $(this),
                    key = $this.find('> a')[0].innerText;

                clearTimeout(onTimer[key]);

                if ($this.hasClass('primary-nav__level-1-item--open')) {
                    offTimer[key] = setTimeout(function () { closeMenu($this); }, 450);
                }
            });

    }

    function openMenu($item) {
        var $menu = $item.find('.primary-nav__menu');

        focusList = [];
        focusIndex = 0;

        $.each($menu.find('a'), function () {
            focusList.push(this);
        });

        App.Base.$body.trigger('click');

        $item
            .addClass('primary-nav__level-1-item--open')
            .find('> a')
            .attr('aria-expanded', 'true');

        $menu
            .off('animationend')
            .addClass('animate__animated fadeInMenu')
            .addClass('d-flex');

        currentMenu = $item;
        App.Header.closeLogin($item);
        if ($('#button-login').hasClass('header-primary__login--open')) {
            $('#button-login').removeClass('header-primary__login--open');
            $('#button-login').attr('aria-expanded', 'false');
        }

    }

    function closeMenu($item) {
        var $menu = $item.find('.primary-nav__menu');

        $item
            .removeClass('primary-nav__level-1-item--open')
            .find('> a')
            .attr('aria-expanded', 'false');

        $menu
            .one('animationend', function () {
                $menu
                    .removeClass('animate__animated fadeOutMenu')
                    .removeClass('d-flex');
            })
            .removeClass('fadeInMenu')
            .addClass('fadeOutMenu');

        if ($item.siblings('.primary-nav__level-1-item--open').length === 0) {
            currentMenu = null;
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.PrimaryNav.init();
});